<template>
	<v-btn rounded @click="click()">
		<v-icon left>{{icon}}</v-icon>
		{{$t(`common.${type}`)}}
	</v-btn>
</template>

<script>
export default {
	name: 'BackButton',
	props: {
		type: {
			type: String,
			default: 'back',
			validator: function (value) {
				return ['back', 'close'].indexOf(value) !== -1;
			},
		},
	},
	computed: {
		icon: {
			get() {
				if (this.type === 'back') {
					return 'fa-arrow-left';
				}

				return 'fa-times';
			}
		}
	},
	methods: {
		click() {
			if (this.type === 'back') {
				history.back();
			} else {
				this.$emit('click', event);
			}
		},
	},
};
</script>